// @tennis-matches/services/winterdoppel/sessionStatus

import { isWinterDoppelPlanFinal } from "./planLock.js";

/** Technische DB-Werte (winterdoppel_sessions.status) */
export const WINTERDOPPEL_SESSION_STATUS = Object.freeze({
  PROPOSED: "proposed",
  ASKED: "asked",
  CONFIRMED: "confirmed",
  CANCELLED: "cancelled",
});

/** UI-Schlüssel für i18n winterdoppel.sessionStatus.* */
export const WINTERDOPPEL_SESSION_UI_STATUS = Object.freeze({
  NOT_PUBLISHED: "notPublished",
  RSVP_RUNNING: "rsvpRunning",
  CONFIRMED: "confirmed",
  CANCELLED: "cancelled",
  COMPLETED: "completed",
});

function __sessionDate(session) {
  return String(session?.session_date || "").slice(0, 10);
}

function __isPastSession(session, todayIso) {
  const d = __sessionDate(session);
  const today = String(todayIso || "").slice(0, 10);
  if (!d || !today) return false;
  return d < today;
}

/**
 * Zentraler Terminstatus für die UI.
 * „Abgeschlossen“ wird aus dem Datum abgeleitet (kein DB-Feld).
 *
 * @param {object|null|undefined} session
 * @param {object|null|undefined} series
 * @param {{ today?: string }} [opts]
 * @returns {typeof WINTERDOPPEL_SESSION_UI_STATUS[keyof typeof WINTERDOPPEL_SESSION_UI_STATUS]}
 */
export function resolveWinterDoppelSessionUiStatus(
  session,
  series,
  { today } = {},
) {
  const raw = String(session?.status || WINTERDOPPEL_SESSION_STATUS.PROPOSED);
  if (raw === WINTERDOPPEL_SESSION_STATUS.CANCELLED) {
    return WINTERDOPPEL_SESSION_UI_STATUS.CANCELLED;
  }
  if (__isPastSession(session, today)) {
    return WINTERDOPPEL_SESSION_UI_STATUS.COMPLETED;
  }
  if (!isWinterDoppelPlanFinal(series)) {
    return WINTERDOPPEL_SESSION_UI_STATUS.NOT_PUBLISHED;
  }
  if (raw === WINTERDOPPEL_SESSION_STATUS.CONFIRMED) {
    return WINTERDOPPEL_SESSION_UI_STATUS.CONFIRMED;
  }
  return WINTERDOPPEL_SESSION_UI_STATUS.RSVP_RUNNING;
}

/**
 * @param {object|null|undefined} session
 * @param {object|null|undefined} series
 * @param {{ today?: string }} [opts]
 * @returns {string} i18n-Key winterdoppel.sessionStatus.*
 */
export function winterDoppelSessionStatusLabelKey(session, series, opts = {}) {
  const ui = resolveWinterDoppelSessionUiStatus(session, series, opts);
  return `winterdoppel.sessionStatus.${ui}`;
}

/**
 * @deprecated Nutze resolveWinterDoppelSessionUiStatus / winterDoppelSessionStatusLabelKey.
 * Behält technische Keys für bestehende Aufrufer während der Migration.
 */
export function resolveWinterDoppelSessionDisplayStatus(session, series) {
  const raw = String(session?.status || "proposed");
  if (raw === "cancelled") return "cancelled";
  if (!isWinterDoppelPlanFinal(series)) return "proposed";
  return raw;
}
